module.exports = __webpack_public_path__ + "static/media/6941640761756IMG_5909.3151d104.jpg";